var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"form-group"},[_vm._t("default"),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.props.value},on:{"input":function($event){return _vm.listeners.input($event.target.value)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }